


































import { Component, Vue, Watch, Prop } from 'vue-property-decorator'
import { Action, Mutation } from 'vuex-class'
import { mapState } from 'vuex'
import { Fragment } from 'vue-fragment'
import Loader from '@/components/gambling/Loader.vue'
import { layoutTwoStyles } from '@/utils/customStyles'

declare global {
  interface Window {
    CashierInstance: any,
    _PaymentIQCashierReset: any
  }
}

declare function _PaymentIQCashier(arg: any, arg1: any, arg2: any): any

@Component({
  components: {
    Fragment,
    Loader
  },
  computed: {
    ...mapState({
      reloadCashier: ({ cashierContext }: any): number => cashierContext.reloadCashier,
      config: ({ cashierContext }: any): object => cashierContext.config,
      theme: ({ cashierContext }: any): object => cashierContext.theme,
      customCss: ({ cashierContext }: any): string => cashierContext.customCss,
      accountType: ({ gamblingContext }: any): string => gamblingContext.accountType,
      cashierSpinner: ({ cashierContext }: any): object => cashierContext.cashierSpinner,
      pageLayout: ({ gamblingContext }: any) => gamblingContext.pageLayout,
      extraCustomCSS: ({ cashierContext }: any): number => cashierContext.extraCustomCSS
    })
  }
})

export default class Cashier extends Vue {
  @Action('depositAmount') depositAmount: any
  @Action('subtractAmount') subtractAmount: any
  @Action('setCurrency') setCurrency: any
  @Action('reloadCashier') reloadCashierAction: any

  @Prop({ type: Function, required: false, default: () => null }) customFunction!: any
  @Prop({ type: String, required: false }) propColor!: string

  public config: any
  public cashier: any
  public showCashier: boolean = false
  public $smallScreen!: boolean
  public theme!: object
  public customCss!: string
  public accountType!: string
  public cashierSpinner!: string
  receiptPage: boolean = false
  pageLayout!: string
  extraCustomCSS!: string
  $cashierConfigs!: any

  @Watch('reloadCashier')
  onReloadCashier (): void {
    const cashierContainer: HTMLElement | null = document.querySelector('#cashier-preview')
    if (cashierContainer) {
      this.showCashier = false
      cashierContainer.innerHTML = '<div></div>'
      this.loadCashierInstance()
    }
  }

  get loaderColor () {
    const staticColor = this.$route.path === '/gambling/account' ? 'white--text' : 'secondary--text'
    return this.propColor || staticColor
  }

  private displaySpinner (type: string): boolean {
    return this.cashierSpinner === 'all' || this.cashierSpinner === type
  }

  private triggerReloadCashier () {
    this.customFunction('reloadCashier')
    this.reloadCashierAction()
  }

  private depositOrWithdrawAmountMethod (amount: number) {
    const { method } = this.config
    const theAmount = Number(amount)
    if (method === 'deposit') {
      this.depositAmount([ theAmount, 'deposit' ])
    } else if (method === 'withdrawal') {
      this.subtractAmount(theAmount)
    }
  }

  private setShowCashier () {
    this.showCashier = true
  }

  private loadCashierInstance () {
    let extraCss = ''
    const gridModeMargin = this.$route.path !== '/gambling/account' && '.grid-mode .max-width-grid{margin-top:30px!important}'
    const cashierWithHeader = this.$route.path === '/gambling' && this.pageLayout === 'layout2' && `
      .header {
        position:absolute!important;
        width: 100%;
        top: 78px;
        width: 94%;
      }
      .payment-method-details {
        margin-top: 50px;
      }
    `
    const { customCss, extraCustomCSS } = this
    const { bgColor, themedCashierWithTabs, checkoutText } = layoutTwoStyles(extraCustomCSS)
    if (this.pageLayout === 'layout2') {
      extraCss = themedCashierWithTabs
    }
    const configsByAccountType: any = {}
    if (this.$route.path.includes('/gambling/account')) {
      if (this.accountType === 'history') {
        configsByAccountType.showTransactionsOnly = true
        configsByAccountType.tabs = false
        configsByAccountType.amount = null
        configsByAccountType.amountFirst = false
      } else {
        configsByAccountType.showTransactionsOnly = false
      }
    }
    const listType = this.$smallScreen && 'list'
    const pageConfigs = this.getPageConfigs()
    try {
      const mergedConfig = {
        ...this.config,
          containerWidth: '100%',
          containerHeight: 'auto',
          ...pageConfigs && { ...pageConfigs },
          ...listType && { listType },
          ...configsByAccountType,
          theme: {
            ...this.theme,
            buttons: {
              color: bgColor
            }
          }
      }
      console.log(mergedConfig)
      this.cashier = new (_PaymentIQCashier as any)('#cashier-preview',
        mergedConfig,
        (api: any) => {
          if (this.config.lookupConfig) {
            // Does not have a separate callback yet so just show the whole thing when this is triggered
            this.setShowCashier()
          }
          api.on({
            cashierInitLoad: () => {
              this.setShowCashier()
            },
            doneLoading: () => {
              this.customFunction('cashierDoneLoading')
            },
            update: (data: any) => console.log('The passed in data was set', data),
            success: (data: any) => {
              console.log('Transaction was completed successfully', data)
              if (data.data.status === 'SUCCESSFUL') {
                const amount = Math.ceil(data.data.payload.txAmount)
                this.depositOrWithdrawAmountMethod(amount)
              } else if (data.data.status === 'WAITING_APPROVAL') {
                this.setCurrency()
              }
              this.customFunction('done')
            },
            isHidden: () => {
              this.customFunction('isHidden')
            },
            isVisible: () => {
              this.customFunction('isVisible')
            },
            failure: (data: any) => console.log('Transaction failed', data),
            newProviderWindow: (data: any) => console.log('A new window / iframe has opened', data),
            paymentMethodSelect: (data: any) => console.log('Payment method was selected', data),
            paymentMethodPageEntered: (data: any) => console.log('New payment method page was opened', data)
          })
          api.css(`
            #cashier {
              width: 100%;
              max-width: 650px;
            }
            .cashier-button {
              width: 100%;
            }
            div[type="PROCESS_PROCESS_REDIRECT"]{margin-top:15px}
            ${gridModeMargin}
            .single-page-flow-container {
              margin-bottom: -40px;
            }
            .transaction-overview,
            .submit-button-container .transaction-overview {
              display:none!important;
            }
            iframe[name=provider-redirect-iframe_PROCESS_PROCESS_REDIRECT],
            iframe.provider-iframe {
              margin-top: 30px;
            }
            .no-select.notranslate {
              color: ${checkoutText}!important;
              border: 1px solid ${checkoutText}!important;
            }
          ${customCss}
          ${extraCss}
          ${cashierWithHeader}
          `)
        }
      )
      window.CashierInstance = this.cashier
    } catch (err) {
      console.log(err)
      setTimeout(() => {
        this.loadCashierInstance()
      }, 200)
    }
  }
  private setTransactionsConfigs () {
    const transactionMode = {
      tabs: false,
      amountFirst: false,
      showTransactionsOnly: true
    }
    return transactionMode
  }
  private setDepWitConfigs () {
    const standard = {
      amountFirst: true,
      containerWidth: '700px'
    }
    return standard
  }
  private getPageConfigs () {
    const { accountType } = this
    if (this.pageLayout === 'layout2') {
      return {}
    } else if (accountType === 'account') {
      return this.setDepWitConfigs()
    } else if (accountType === 'history') {
      return this.setTransactionsConfigs()
    }
  }

  private mounted (): void {
    this.loadCashierInstance()
  }
  private created (): void {
    this.getPageConfigs()
    // window._PaymentIQCashierReset && window._PaymentIQCashierReset()
    window.addEventListener('message', (e) => {
      this.receiptPage = false
      if (e.data.eventType === 'APP_ROUTE_CHANGE') {
        switch (e.data.payload.path) {
          case '/receipt':
          case '/status':
            setTimeout(() => { this.receiptPage = true }, 1000)
            break
          default:
            this.receiptPage = false
            break
        }
      }
    })
  }
  private beforeDestroy (): void {
    this.showCashier = false
  }
}
